import PatientsPopup from './PatientsPopup';

export default PatientsPopup;
